/* eslint-disable import/first, @typescript-eslint/no-var-requires */
import { QueryClient, QueryClientProvider } from '@tanstack/react-query';
import 'core-js/es/map';
import 'core-js/es/set';
import 'promise-polyfill/src/polyfill';
import 'url-search-params-polyfill';


require('array.prototype.find').shim();

import FlagProvider from '@unleash/proxy-client-react';
import React, { useEffect } from 'react';
import { Provider, useDispatch } from 'react-redux';
import { BrowserRouter } from 'react-router-dom';
import { ThemeProvider } from 'styled-components';
import { useFetchInterceptor } from '@hooks/useFetchInterceptos';


import Routes from './Routes';

import store from './store/store';
import { defineUser } from './store/user/actions';

import { getUserData } from './services/localSorage';

import SentryContainer from './components/application/SentryContainer';

import Sentry from './monitoring/sentry';

import * as Styles from './AppStyles';
import { GlobalStyles } from './styles';
import { createTheme } from './styles/theme';

import TemporaryAnnouncementsContainer from './components/application/TemporaryAnnouncements/TemporaryAnnouncementsContainer';
import XRayTrackerContainer from './components/application/XRayTrackerContainer/XRayTrackerContainer';
import ZendeskButton from './components/application/ZendeskButton';
import { unleashClient } from './services/unleash/unleash';


const theme = createTheme();

const App: React.FC = () => {
  const { user, token } = getUserData();

  const dispatch = useDispatch();

  const MAX_RETRIES = 3;
  const TIMEOUT = 3000;

  const identifyUserCrazyEgg = (userId: number): void => {
    CE2.identify(userId);
  }

  const retryIdentifyUserCrazyEggWithTimeout = (userId: number, retryCount = 0): void => {
    if (retryCount >= MAX_RETRIES) {
      return;
    }

    try {
      identifyUserCrazyEgg(userId);
    } catch (error) {
      // Aguarda o tempo especificado antes de tentar novamente
      setTimeout(() => {
        retryIdentifyUserCrazyEggWithTimeout(userId, retryCount + 1);
      }, TIMEOUT);
    }
  }

  /*
   * Ao recarregar ou voltar para a aplicação, redefine usuário e token
   */
  useEffect(() => {
    if (user && token) {
      dispatch(defineUser(user, token));
      Sentry.setDrugstoreUser(user);
      // Tentar identificar o usuário no Crazy Egg com retentativas
      retryIdentifyUserCrazyEggWithTimeout(user.id);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [dispatch, user, token]);

  useFetchInterceptor({
    developmentOnlyCallback: (info) => {
      if (!info.payload) return;
      if (!info.payload.properties) return;
      console.log({
        event: info.payload.event,
        payload: info.payload.properties,
        type: info.payload.type,
      });
    }
  });



  return (
    <ThemeProvider theme={theme}>
      <Styles.Container>
        <SentryContainer />
        <XRayTrackerContainer />
        <GlobalStyles />
        <BrowserRouter basename='/receita'>
          <Routes />
          <TemporaryAnnouncementsContainer />
          <ZendeskButton />
        </BrowserRouter>
      </Styles.Container>
    </ThemeProvider>
  );
};

const AppWrapper: React.FC = () => {

  const queryClient = new QueryClient({
    defaultOptions: {
      queries: {
        refetchOnWindowFocus: false,
        refetchOnMount: false,
      },
    }
  });

  return <Provider store={store}>
    <QueryClientProvider client={queryClient}>

      <FlagProvider unleashClient={unleashClient} startClient={false}>
        <App />
      </FlagProvider>
    </QueryClientProvider>

  </Provider>
}


export default AppWrapper;
